/**
 * A service token's secret, shown once. Issuing and rotating both return the
 * plaintext in the response and never again, so both end here.
 */
import type { ServiceTokenIssue } from '@optum/api-client/types';

import { Button } from '../../ui/Button.js';
import { Dialog, DialogActions } from '../../ui/Dialog.js';

export function TokenRevealDialog({
  secret,
  onClose,
}: {
  secret: ServiceTokenIssue | null;
  onClose: () => void;
}) {
  return (
    <Dialog
      open={Boolean(secret)}
      onClose={onClose}
      title="Save this secret now"
      subtitle="This is the only time you will see it. After this dialog closes we can only rotate it."
    >
      {secret && (
        <div style={{ marginTop: 16, display: 'flex', flexDirection: 'column', gap: 7 }}>
          <div style={{ fontSize: 'var(--text-meta-lg)', color: 'var(--text-muted)' }}>Label</div>
          <div style={{ fontWeight: 'var(--weight-medium)' }}>{secret.label}</div>
          <div style={{ fontSize: 'var(--text-meta-lg)', color: 'var(--text-muted)' }}>Secret</div>
          <code
            style={{
              display: 'block',
              wordBreak: 'break-all',
              borderRadius: 'var(--radius-chip)',
              background: 'var(--surface-sunken)',
              padding: 11,
              fontSize: 'var(--text-body-md)',
            }}
            className="mono"
          >
            {secret.secret}
          </code>
        </div>
      )}
      <DialogActions>
        <Button variant="primary" onClick={onClose}>
          I have saved it
        </Button>
      </DialogActions>
    </Dialog>
  );
}
